import {
  ImageObjectTags,
  TextObjectTags,
  VideoObjectTags,
} from '../../../../team-apis/otterdam/annotations';
import { AnnotationState, AnnotationTransientState } from './annotation-state';

export interface ObjectTransientInfoState extends AnnotationTransientState {
  hasMissingClass: boolean;
}

export interface ObjectState extends AnnotationState {
  parentId?: number;
  sortIndex: number;
  class?: string;
  childObjectIds: number[];
  childShapeIds: number[];
}

export interface ImageObjectState extends ObjectState {
  class: 'image';
  tags: ObjectState['tags'] & ImageObjectTags;
}

export interface VideoObjectState extends ObjectState {
  class: 'video';
  tags: ObjectState['tags'] & VideoObjectTags;
}

export interface TextObjectState extends ObjectState {
  class: 'text';
  tags: ObjectState['tags'] & TextObjectTags;
}

export interface ItemObjectState extends ObjectState {
  class: 'item';
  childObjectIds: [number, number];
}

export interface ContextObjectState extends ObjectState {
  class: 'context';
}

export interface AnnotationsObjectState extends ObjectState {
  class: 'annotations';
}

export function isPromptObject(objectState: ObjectState) {
  return objectState.class === 'prompt';
}

export function isResponseObject(objectState: ObjectState) {
  return objectState.class === 'response';
}

export function isImageObjectState(
  objectState: ObjectState,
): objectState is ImageObjectState {
  return objectState.class === 'image';
}

export function isVideoObjectState(
  objectState: ObjectState,
): objectState is VideoObjectState {
  return objectState.class === 'video';
}

export function isTextObjectState(
  objectState: ObjectState,
): objectState is TextObjectState {
  return objectState.class === 'text';
}

export function isContextObject(
  objectState: ObjectState,
): objectState is ContextObjectState {
  return objectState.class === 'context';
}

export function isAnnotationsObject(
  objectState: ObjectState,
): objectState is AnnotationsObjectState {
  return objectState.class === 'annotations';
}

export function isItemObject(
  objectState: ObjectState,
): objectState is ItemObjectState {
  return objectState.class === 'item';
}
